
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL + "/api/potongan";

export const getPotonganList = async (karyawan_id,periode) => {
  const params = {};
  if (karyawan_id != null && karyawan_id !== "") {
    params.karyawan_id = karyawan_id;
  }
  if (periode != null && periode !== "") {
    params.periode = periode;
  }

  const response = await axios.get(BASE_URL, { params });
  return response.data;
};


export const createPotongan = async (data) => {
  const response = await axios.post(`${BASE_URL}`, data);
  return response.data;
};


export const updatePotongan = async (id, data) => {
  const response = await axios.put(`${BASE_URL}/${id}`, data);
  return response.data;
};

export const deletePotongan = async (id) => {
  const response = await axios.delete(`${BASE_URL}/${id}`);
  return response.data;
};
